import { Action } from 'redux-actions';
import { EventChannel, eventChannel } from 'redux-saga';
import { ActionPattern, call, fork, take } from 'redux-saga/effects';
import {
  SET_CHART_DATA,
  SET_VPMES_DATA,
  SET_VPMNDX_DATA,
  SET_VPMNQ_DATA,
  SET_VPMSPX_DATA,
} from '../socket/constants';

interface ISubscription {
  id: number,
  cb: (data: { name: string, data: any; }) => void;
}

interface ISubscribers {
  [key: string]: {
    callbacks: ISubscription[];
  };
}

// @ts-ignore
const worker = new SharedWorker('/assets/socket.worker.js');

const subscribers: ISubscribers = {
  [SET_VPMES_DATA]: { callbacks: [] },
  [SET_VPMSPX_DATA]: { callbacks: [] },
  [SET_VPMNQ_DATA]: { callbacks: [] },
  [SET_VPMNDX_DATA]: { callbacks: [] },
  [SET_CHART_DATA]: { callbacks: [] },
  'sym:ES:ohlc': { callbacks: [] },
  'sym:NQ:ohlc': { callbacks: [] },
};

export function initializeStore(token: string) {
  worker.port.postMessage({ action: 'init', token });
}

export function deinitializeStore() {
  worker.port.postMessage({ action: 'deinit' });
}

export function getSubscribers() {
  worker.port.postMessage({ action: 'subscriptions' });
}

export function subscribeListener(channelName: string, id: number, cb: (data: { name: string, data: any; }) => void) {
  // temp to manage models with olhc
  if (!subscribers[channelName]) {
    subscribers[channelName] = {
      callbacks: [],
    };
  }
  // only subscribe it there is not already a subscription
  if (subscribers[channelName].callbacks.length === 0) {
    worker.port.postMessage({ action: 'subscribe', channelName, id });
    /* eslint-disable no-console */
    console.log("Subscribe to " + channelName + " id: " + id);
    /* eslint-enable no-console */
  } else {
    worker.port.postMessage({ action: 'get', channelName, id });
  }

  subscribers[channelName].callbacks.push({ id, cb });
}

export function unsubscribeListener(channelName: string, id: number) {
  // temp to manage models with olhc
  try {
    subscribers[channelName].callbacks = subscribers[channelName].callbacks.filter(
      cb => cb.id !== id,
    );
    // only unsubscribe it there is no more subscriptions
    if (subscribers[channelName].callbacks.length === 0) {
      worker.port.postMessage({ action: 'unsubscribe', channelName, id });
      /* eslint-disable no-console */
      console.log("Unsubscribe to " + channelName + " id: " + id);
       /* eslint-enable no-console */
    }
  } catch (e) {
    // debug
  }
}

export function postMessageToServer(id: string, message: any) {
  worker.port.postMessage({ action: 'post', id, message });
}

function initWebSocket(): EventChannel<unknown> {
  return eventChannel(emitter => {
    worker.port.onmessage = ({ data }: any) => {
      emitter(data);
    };
    return () => {
      worker.port.removeEventListener('message', emitter);
    };
  });
}

function* watchWebSocket() {
  const channel: ActionPattern<Action<any>> = yield call(initWebSocket) as unknown;

  worker.port.postMessage({ action: 'init', token: localStorage.getItem('token') });
  while (true) {
    const message: { id: string, data: any | undefined; } = yield take(channel) as unknown;
    const subscriber = subscribers[message.id];

    if (subscriber && subscriber.callbacks.length > 0) {
      const newMessage = message.data ? message : { data: { data: {} }, id: message.id };
      subscriber.callbacks.forEach(cb => cb.cb(newMessage as any));
    }
  }
}

export function* sagaWatcher() {
  yield fork(watchWebSocket);
}


const gens = [sagaWatcher()];
export default gens;
